import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp'
import {
  Anchor,
  Button,
  Card,
  Collapse,
  Flex,
  Title,
  Text,
} from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import clsx from 'clsx'
import React from 'react'

import { useTranslation } from '@flecto/translations'

import useMediaQuery from '../../lib/utils/useMediaQuery'
import { colors } from '../../src/themes/mantine/tokens'
import { Badge } from '../Badge/Badge'
import { Icon } from '../Icon/Icon'
import styles from './styles.module.css'

interface BoxCollapsibleProps {
  children: React.ReactNode
  title: string
  badge?: number
  disabled?: boolean
  viewAll?: () => void
}

export const BoxCollapsible: React.FC<BoxCollapsibleProps> = ({
  children,
  title,
  badge = 0,
  disabled = false,
  viewAll,
}) => {
  const { t: tBooking } = useTranslation('saas', { keyPrefix: 'booking' })
  const [opened, { toggle }] = useDisclosure(true)
  const { isDesktop } = useMediaQuery()

  return (
    <Flex direction={'column'}>
      {isDesktop && (
        <Flex
          columnGap='md'
          wrap='nowrap'
          align='center'
          justify='space-between'
        >
          <Flex columnGap='sm' wrap='nowrap' align='center' justify='start'>
            <Title order={5}>{title}</Title>
            {badge > 0 && (
              <Badge size='sm' bg={colors.gray[2]}>
                <Text color='gray.7' fw={500}>
                  {badge}
                </Text>
              </Badge>
            )}
          </Flex>
          <Flex columnGap='sm' wrap='nowrap' align='center' justify='start'>
            {viewAll && (
              <Anchor
                onClick={disabled ? undefined : viewAll}
                className={clsx(styles.link, {
                  [styles.linkDisabled]: disabled,
                })}
              >
                {tBooking('booking_documents.view_all_documents')}
              </Anchor>
            )}
            <Button
              onClick={toggle}
              variant='transparent'
              size='xs'
              w={40}
              px={0}
              color='black'
            >
              <Icon icon={opened ? faChevronUp : faChevronDown} />
            </Button>
          </Flex>
        </Flex>
      )}

      <Flex direction={'column'} rowGap='md' mt={isDesktop ? 'md' : 0}>
        <Collapse in={opened}>
          <Card withBorder>
            {children}
            {!isDesktop && viewAll && (
              <Flex align='center' p='sm' justify='center' mt='sm'>
                <Anchor
                  onClick={disabled ? undefined : viewAll}
                  className={clsx(styles.link, {
                    [styles.linkDisabled]: disabled,
                    [styles.linkMobile]: true,
                  })}
                >
                  {tBooking('booking_documents.view_all_documents')}
                </Anchor>
              </Flex>
            )}
          </Card>
        </Collapse>
      </Flex>
    </Flex>
  )
}
